import { useMutation } from 'react-query';
import moment from 'moment';
import 'moment-timezone';
import {
  BlackoutService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackOutGroupDto,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackoutTitleDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetTradingBlackoutConfigView = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setBlackoutConfigView: any
): any => {
  return useMutation(
    async (data: { id: string; modalStatus?: string }) => {
      return await handleRequest(
        BlackoutService.getApiCustomerApiAppBlackoutBlackoutById(data?.id)
      );
    },
    {
      onSuccess: (response: any, context: { id: string; modalStatus: string }) => {
        if (response != null) {
          // Convert API response dates (which may be in NST or other timezone) to EST
          const startDateTime = response?.startDate
            ? moment(response.startDate).tz('America/New_York')
            : null;
          const endDateTime = response?.endDate
            ? moment(response.endDate).tz('America/New_York')
            : null;

          const filteredResponse = {
            ...response,
            originalStartDate: response?.startDate ?? null,
            originalEndDate: response?.endDate ?? null,
            // For Repurpose mode, clear dates. Otherwise split datetime into date + time (EST)
            startDate: context?.modalStatus?.includes('Repurpose')
              ? null
              : startDateTime
                ? new Date(startDateTime.format('YYYY-MM-DD')) // Extract date only to avoid timezone shift
                : null,
            startTime: context?.modalStatus?.includes('Repurpose')
              ? null
              : startDateTime?.format('HH:mm') ?? null,
            endDate: context?.modalStatus?.includes('Repurpose')
              ? null
              : endDateTime
                ? new Date(endDateTime.format('YYYY-MM-DD')) // Extract date only to avoid timezone shift
                : null,
            endTime: context?.modalStatus?.includes('Repurpose')
              ? null
              : endDateTime?.format('HH:mm') ?? null,
            // Initialize checkbox states - set based on API response if available
            startImmediately: response?.isImmediateStart ?? false,
            blackoutGroups: response.blackoutGroups.map(
              // eslint-disable-next-line camelcase
              (group: Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackOutGroupDto) => ({
                ...group,
                groupData: true,
                blackOutJobTitles: group?.blackOutJobTitles?.map(
                  // eslint-disable-next-line camelcase
                  (item: Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackoutTitleDto) =>
                    item.customerTitleId
                ),
              })
            ),
          };
          setBlackoutConfigView(filteredResponse);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetTradingBlackoutConfigView;
